import { Box } from '@material-ui/core'
import { unwrapResult } from '@reduxjs/toolkit'
import GoBack from 'components/GoBack'
import FitContentPaper from 'components/Paper/FitContentPaper'
import { FormikHelpers } from 'formik'
import useRestricter from 'hooks/useRestricter'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { RouteConfigComponentProps } from 'react-router-config'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { selectCurrentTempleStaffProfiles, staffProfileListThunk } from 'store/reducers/temple/staffProfileSlice'
import { selectStaffTimeOffStatus, staffTimeOffApplyThunk } from 'store/reducers/temple/staffTimeOffSlice'
import { StaffTimeOffPayloadType } from 'types/api/temple'
import { getFieldErrors } from 'utils/api'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'
import FormStaffTimeOff from './FormStaffTimeOff'

const AddStaffTimeOff: React.FC<RouteConfigComponentProps> = props => {
    const dispatch = useAppDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const api = useAppSelector(selectStaffTimeOffStatus)
    const profiles = useAppSelector(selectCurrentTempleStaffProfiles)
    const hasAddPermission = useRestricter(PERMISSIONS.ADD, RESTRICTED_PATHS.STAFF_TIME_OFF)

    useEffect(() => {
        dispatch(staffProfileListThunk({}))
    }, [dispatch])

    const handleSubmit = (data: StaffTimeOffPayloadType, actions: FormikHelpers<StaffTimeOffPayloadType>) => {
        dispatch(staffTimeOffApplyThunk(data))
            .then(unwrapResult)
            .then(response => {
                enqueueSnackbar(`Time off applied for ${response.staffName}`, { variant: 'success' })
                actions.resetForm()
            })
            .catch(err => {
                Object.entries(getFieldErrors(data, err)).forEach(([key, value]) => actions.setFieldError(key, value))
            })
            .finally(() => actions.setSubmitting(false))
    }

    if (!hasAddPermission) return null

    return (
        <GoBack {...props}>
            <FitContentPaper>
                <Box component='h4' mb={4}>Apply Staff Time Off</Box>
                <FormStaffTimeOff
                    profiles={profiles}
                    buttonLabel='Apply'
                    api={api}
                    onSubmit={handleSubmit}
                />
            </FitContentPaper>
        </GoBack>
    )
}

export default AddStaffTimeOff
